import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { setStartDate, getStartDate } from '../../store/slices/domainOrchestratorPricingCommittee.slice';

export const StartDateFilter = () => {
  const dispatch = useDispatch();
  const startDate = useSelector(getStartDate);

  useEffect(() => {
    if (!startDate) {
      const today = new Date().toISOString().slice(0, 10);
      dispatch(setStartDate(today));
    }
  }, [startDate, dispatch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setStartDate(e.target.value));
  };

  return (
    <Form.Control
      type="date"
      value={startDate}
      onChange={handleChange}
      style={{ fontSize: '14px' }}
    />
  );
};
